import { ErpSessionSimpleResponse } from 'com.cogvio.pricemonitor.api';
import { useState, useEffect } from 'react';
import { parseTemplate } from 'url-template';
import ApiClient from '~/ApiClient';

export const useGetSessions = (client: ApiClient | null, userId: string) => {
	const [sessions, setSessions] = useState<ErpSessionSimpleResponse[]>([]);

	useEffect(() => {
		(async () => {
			const url = parseTemplate('users/{userId}/erp/sessions');
			const request = await client?.fetch(url.expand({ userId }));
			const response = await request?.json();
			setSessions(response.items);
		})();
	}, []);

	return sessions;
};
